import React from "react";
import { Col, Row } from "react-bootstrap";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import { theme as themeConfig } from "../../themes/themes";
import { ContentMySpaces, useStyles } from "./MySpaces.styled";
import ListCardMySpaces from "../ListCardMySpaces";

const MySpaces = ({
  loadingMySpacesFirst,
  errorMySpacesFirst,
  myspaces,
  goToDetail,
  isHomeView,
}) => {
  const classes = useStyles();

  return (
    <ContentMySpaces>
      <Row className={classes.containMySpaces}>
        <Col md={12} className={classes.bodyMySpaces}>
          {loadingMySpacesFirst && !errorMySpacesFirst && (
            <Row>
              <Col
                md="12"
                className="d-flex justify-content-center align-content-center my-5"
              >
                <PointersLine color={themeConfig.text.primary} />
              </Col>
            </Row>
          )}
          {!loadingMySpacesFirst && errorMySpacesFirst && (
            <Row>
              <Col
                md="12"
                className="d-flex justify-content-center align-content-center my-5"
              >
                <h1 style={{ color: "#ccc" }}>Error :(</h1>
              </Col>
            </Row>
          )}
          {!loadingMySpacesFirst && !errorMySpacesFirst && (
            <Row className={classes.rowContainMySpaces} style={isHomeView && {
              width: "100%",
              height: "13em",
              flexDirection: "column-reverse"
            }}>
              {myspaces &&
                myspaces?.length > 0 &&
                myspaces.map((myspace, index) => {
                  return (
                    <ListCardMySpaces
                      goToDetail={goToDetail}
                      myspace={myspace}
                      key={index}
                      isHomeView={isHomeView}
                    />
                  );
                })}
            </Row>
          )}
        </Col>
      </Row>
    </ContentMySpaces>
  );
};

export default MySpaces;
